import Page from "./page"
import Blog from "./blog"
import CareerTeaser from "./career-teaser"
import CareerTeasers from "./career-teasers"
import CareerFacesTeaser from "./career-faces-teaser"
import ComponentNotFound from "./component-not-found"
import ContactViaMail from "./contact-via-mail"
import ContactViaMailContainer from "./contact-via-mail-container"
import TwoColsText from "./two-cols-text"
import TwoCols from "./two-cols"
import OneCol from "./one-col"
import CallToActionArea from "./call-to-action-area"
import SmallBlogTeasers from "./small-blog-teasers"
import SmallBlogTeaser from "./small-blog-teaser"
import BigBlogTeasers from "./big-blog-teasers"
import BigBlogTeaser from "./big-blog-teaser"
import BlogListing from "./blog-listing"
import Glossar from "./glossar"
import Slider from "./slider"
import Slide from "./slide"
import FullWidthSlide from "./fullwidth-slide"
import ImageWithTeaserBox from "./image-with-teaser-box"
import PieChart from "./pie-chart"
import PageTeasers from "./page-teasers"
import PageTeaser from "./page-teaser"
import ContentpageTwoColumn from "./contentpage-two-column"
import Locations from "./locations"
import LocationTeaser from "./location-teaser"
import ContentPageTeaser from "./contentpage-teaser"
import Headline from "./headline"
import Quote from "./quote"
import SpecialHeader from "./special-header"
import Form from "./form"
import FormBuWater from "./form-bu-water"
import Input from "./input"
import Textarea from "./textarea"
import Select from "./select"
import LocationSelect from "./location-select"
import Checkbox from "./checkbox"
import DepartmentSelect from "./department-select"
import Radiobutton from "./radiobutton"
import FieldGroup from "./field-group"
import InputTable from "./input-table"
import Captcha from "./captcha"
import DatePicker from "./date-picker"
import FormDetails from "./form-details"
import FormInfo from "./form-info"
import FormSubmit from "./form-submit"
import Steps from "./steps"
import Step from "./step"
import Sdgs from "./sdgs"
import AlternativeBackground from "./alternative-background"
import LogoGallery from "./logo-gallery"
import LogoGalleryItem from "./logo-gallery-item"
import PageOverview from "./page-overview"
import GlobalForm from "./global-form"
import GlobalComponent from "./global-component"
import BIteTool from "./b-ite-tool"
import ThreeColumnText from "./three-cols-text"
import PharmaMailchimp from "./pharma-mailchimp"
import Video from "./video"
import Iframe from "./iframe"
import ShopItem from "./shop-item"
import Shop from "./shop"
import Timeline from "./timeline"
import Login from "./login"
import Recover from "./recover"
import PasswordReset from "./password-reset"
import GuteSiegelProducteSearch from "./gutesiegel/product-search"
import Confirm from "./confirm"
import LoginDetails from "./login-details"
import ShopWrapper from "./shop-wrapper"
import BUWaterWrapper from "./bu-water-wrapper"
import BuWaterName from "./bu-water-name"
import BackButton from "./back-button"
import Button from "./button"
import LkfNewsListing from "./lkf-news-listing"
import LkfNewsTeaser from "./lkf-news-teaser"
import LkfNews from "./lkfNews"
import ShortNews from "./short-news"
import Testimonial from "./testimonial"
import Row from "./row"
import BannerNews from "./banner-news"
import FullwidthBanner from "./fullwidth-banner"
import JobsTable from "./jobs-table"
import Job from "./job"
import SitesWrapper from "./site/sites-wrapper"
import SitesListing from "./site/sites-listing"
import SitesFilter from "./site/sites-filter"
import ContactTeaser from "./contact-teaser"
import VideoTeaser from "./video-teaser"
import Columns from "./columns"

const ComponentList = {
  page: Page,
  formPage: Page,
  blog: Blog,
  careerTeaser: CareerTeaser,
  careerTeasers: CareerTeasers,
  careerFacesTeaser: CareerFacesTeaser,
  contactViaMail: ContactViaMail,
  contactViaMailContainer: ContactViaMailContainer,
  globalForm: GlobalForm,
  globalComponent: GlobalComponent,
  twoColsText: TwoColsText,
  twoCols: TwoCols,
  oneCol: OneCol,
  callToActionArea: CallToActionArea,
  smallBlogTeasers: SmallBlogTeasers,
  smallBlogTeaser: SmallBlogTeaser,
  bigBlogTeasers: BigBlogTeasers,
  bigBlogTeaser: BigBlogTeaser,
  bigPageTeaser: BigBlogTeaser,
  glossar: Glossar,
  pageOverview: PageOverview,
  blogListing: BlogListing,
  slider: Slider,
  slide: Slide,
  fullWidthSlide: FullWidthSlide,
  imageWithTeaserBox: ImageWithTeaserBox,
  pieChart: PieChart,
  pageTeasers: PageTeasers,
  pageTeaser: PageTeaser,
  contentpageTwoColumn: ContentpageTwoColumn,
  locations: Locations,
  locationTeaser: LocationTeaser,
  contentPageTeaser: ContentPageTeaser,
  headline: Headline,
  quote: Quote,
  specialHeader: SpecialHeader,
  form: Form,
  formBuWater: FormBuWater,
  buWaterName: BuWaterName,
  formInfo: FormInfo,
  formSubmit: FormSubmit,
  input: Input,
  datePicker: DatePicker,
  textarea: Textarea,
  select: Select,
  locationSelect: LocationSelect,
  checkbox: Checkbox,
  departmentSelect: DepartmentSelect,
  radiobutton: Radiobutton,
  fieldGroup: FieldGroup,
  inputTable: InputTable,
  captcha: Captcha,
  formDetails: FormDetails,
  step: Step,
  steps: Steps,
  sdgs: Sdgs,
  alternativeBackground: AlternativeBackground,
  logoGallery: LogoGallery,
  logoGalleryItem: LogoGalleryItem,
  bIteTool: BIteTool,
  threeColumnText: ThreeColumnText,
  pharmaMailchimp: PharmaMailchimp,
  video: Video,
  iframe: Iframe,
  shop: Shop,
  shopItems: ShopItem,
  login: Login,
  recover: Recover,
  timeline: Timeline,
  confirm: Confirm,
  passwordReset: PasswordReset,
  guteSiegelProducteSearch: GuteSiegelProducteSearch,
  loginDetails: LoginDetails,
  shopWrapper: ShopWrapper,
  buWaterWrapper: BUWaterWrapper,
  backButton: BackButton,
  button: Button,
  lkfNews: LkfNews,
  lkfNewsListing: LkfNewsListing,
  lkfNewsTeaser: LkfNewsTeaser,
  shortNews: ShortNews,
  row: Row,
  testimonial: Testimonial,
  bannerNews: BannerNews,
  fullwidthBanner: FullwidthBanner,
  jobsTable: JobsTable,
  job: Job,
  sitesWrapper: SitesWrapper,
  sitesListing: SitesListing,
  sitesFilter: SitesFilter,
  contactTeaser: ContactTeaser,
  videoTeaser: VideoTeaser,
  columns: Columns,
}

const Components = (type) => {
  if (typeof ComponentList[type] === "undefined") {
    return ComponentNotFound
  }
  return ComponentList[type]
}

export default Components
